import type React from 'react'

export function SettingRow({
  label,
  subtitle,
  children,
  clickable = false,
  onClick,
}: {
  label: string
  subtitle?: string
  children: React.ReactNode
  clickable?: boolean
  onClick?: () => void
}) {
  return (
    <div
      className={`flex items-center justify-between px-4 py-5 ${
        clickable
          ? 'hover:bg-muted/30 transition-colors duration-150 rounded-[4px] cursor-pointer'
          : ''
      }`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                onClick?.()
              }
            }
          : undefined
      }
    >
      <div className="flex flex-col gap-0.5">
        <span className="text-sm font-medium">{label}</span>
        {subtitle && (
          <span className="text-xs text-muted-foreground">{subtitle}</span>
        )}
      </div>
      {children}
    </div>
  )
}

export function Divider() {
  return <div className="border-t border-border mx-4" />
}
